import React, { useEffect, useState, useCallback } from 'react';
import '../../index.css';
import './Wallet.css';
import { SignInButton, ethos } from 'ethos-connect';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Store from '../Store/Store';
import Import from '../Import/Import';
import Bullshark from '../Bullshark/Bullshark';
import { gaEvents } from '../../util/events';

function Wallet(props) {
  const { wallet } = ethos.useWallet();
  const [activeKey, setActiveKey] = useState(3);
  const HEADERS = {
    1: 'In-Game Gear',
    2: 'In-Game Gear',
    3: 'Bullshark Quest',
  };
  const SECOND_HEADERS = {
    1: 'Click a Gear Below to Transfer to Your Wallet',
    2: 'Click a Gear Below to Import to Your Wallet',
    3: 'Check Your Eligibility',
  };
  useEffect(() => {
    if (wallet) {
      // setActiveKey(1);
      const lastTab = window.sessionStorage.getItem('lastTab');
      if (lastTab) {
        setActiveKey(lastTab);
      }
    }
  }, [wallet]);

  const disconnect = useCallback(() => {
    if (!wallet) return;
    wallet.disconnect();
  }, [wallet]);

  function onTabChange(key) {
    setActiveKey(key);
    if (key === 1) {
      gaEvents.switchToTab1();
    } else if (key === 2) {
      gaEvents.switchToTab2();
    } else if (key === 3) {
      gaEvents.switchToTab3();
    }
    window.sessionStorage.setItem('lastTab', key);
  }

  return (
    <div className="section wallet">
      <h1 className="store-header header">{wallet ? HEADERS[activeKey] : 'Connect Wallet'}</h1>
      <h2 className="second-header">{wallet ? SECOND_HEADERS[activeKey] : 'Connect Wallet to see Items'}</h2>
      {!wallet
      && (
      <SignInButton className="wallet-btn">
        Connect
      </SignInButton>
      )}
      {wallet
      && (
      <div>
        <h1 className="wallet-address">
          <span>
            Wallet Address:
            {' '}
            {wallet.address}
          </span>
        </h1>
        <button onClick={disconnect} className="wallet-btn disconnect">Disconnect</button>
        <Tabs className="talofa-tabs" activeKey={activeKey} onSelect={onTabChange} id="uncontrolled-tab-example">
          <Tab className="in-game talfoa-tab" eventKey={1} title="In-Game">
            <Store activeTab={activeKey} walletAddress={wallet.address} userData={props.userData} />

          </Tab>
          <Tab className="import talofa-tab" eventKey={2} title="Import">
            <Import activeKey={activeKey} wallet={wallet} />
          </Tab>
          <Tab className="import talofa-tab" eventKey={3} title="Bullshark">
            <Bullshark activeKey={activeKey} wallet={wallet} />
          </Tab>
        </Tabs>

      </div>
      )}
    </div>
  );
}

export default Wallet;
